// @ts-strict-ignore
import * as React from "react";
import { SubMenuColumn } from "../style";
import NextLink from "components/parts/NextLink";
import { Heading, Body } from "components/parts/Typography";
import type { StaticImageData } from "next/image";
import Image from "next/image";
import leftArrow from "public/images/arrow.svg";
import styled from "styled-components";

const StyledDiv = styled.div<{ bgColor: string }>`
  background-color: ${({ bgColor }) => bgColor};
  max-width: 292px;
  padding: 19px 0px 5px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: flex-start;
  p {
    color: ${({ theme }) => theme.colorPalette.gray[300]};
  }
`;
const HeadingBox = styled.div`
  display: flex;
  align-items: center;
`;

interface NavCardProps {
  isUK?: boolean;
  isSG?: boolean;
  title: string;
  body: string;
  imgSrc: StaticImageData | string;
  bgColor: string;
  path: string;
}

const NavCard = ({
  isUK = false,
  isSG = false,
  title,
  body,
  imgSrc,
  bgColor,
  path
}: NavCardProps) => {
  return (
    <SubMenuColumn>
      <NextLink prefetch={false} href={isUK ? "" : path}>
        <Image height={160} width={300} src={imgSrc} alt={title} />
        {!(isUK || isSG) && (
          <StyledDiv bgColor={bgColor}>
            <HeadingBox>
              <Heading size="md" m="0px 12px 0px 0px" color="white" semiBold>
                {title}
              </Heading>
              <Image height={20} width={20} src={leftArrow} alt="arrow" />
            </HeadingBox>
            <Body size="sm">{body}</Body>
          </StyledDiv>
        )}
      </NextLink>
    </SubMenuColumn>
  );
};

export default NavCard;
